import { render } from "./VideoMessage.vue?vue&type=template&id=d62d80e2&scoped=true&ts=true"
import script from "./VideoMessage.vue?vue&type=script&lang=ts"
export * from "./VideoMessage.vue?vue&type=script&lang=ts"

import "./VideoMessage.vue?vue&type=style&index=0&id=d62d80e2&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d62d80e2"]])

export default __exports__